<script>
export default {
  props: {
    htmlContent: {
      type: String,
      required: true
    }
  }
}
</script>
<template>
    <hr/>
    <div class="text-center p-0 small" v-html="htmlContent"></div>
    <hr/>
</template>